import { enableScroll, stopScroll } from '../__utils/lockScroll';
import NextSteps from '../__header/nextStepsMenu';

const $ = jQuery.noConflict();

const MobileMenuWrapper = $('.main-header__nav-mobile--wrapper');
const MobileMenu = $('.main-header__nav-mobile--inner-wrapper');
class MobileHeader {
    constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.main-header__nav-mobile > .menu > .menu-item.menu-item-type-post_type > a') {
        this.trigger = trigger;
        this.pbody = pbody;
        this.listParent = listParent;
    }
    init() {
        const th = this;
        $(this.trigger).on('click', this.setNavState);
        $(this.listParent).on('click', this.setListState);
        this.makeMenuPosAndHeight();

        $(window).on('resize touchmove', () => {
            th.makeMenuPosAndHeight();
        });
    }
    makeMenuPosAndHeight() {
        const HeaderHeight = $('header.main-header').outerHeight(true);

        MobileMenuWrapper.css({
            'top': HeaderHeight,
            'height': window.innerHeight - HeaderHeight,
        });

        MobileMenu.css({
            'max-height': MobileMenuWrapper.outerHeight(true) - $('.main-header__cta-wrapper--mobile').outerHeight(true),
        });
    }
    setNavState(e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {
            MobileHeader.hideWrapper(this);
            enableScroll();
        } else {
            MobileHeader.showWrapper(this);
            stopScroll();
        }
    }
    setListState(e) {
        e.preventDefault();
        if (!$(this).parent().hasClass('open')) {
            let delay = 0;
            $(this).parent().addClass('open')
                .find('.mega-menu-wrapper').slideDown(200)
                .find('.mega-menu-column')
                .find('a, p')
                .each((i, v) => {
                    delay += 0.07;
                    $(v).css('transition-delay', `${delay}s`);
                    $(v).toggleClass('visible');
                });
        } else {
            $(this).parent().removeClass('open')
                .find('.mega-menu-wrapper').slideUp(200)
                .find('.mega-menu-column')
                .find('a')
                .removeClass('visible');
        }
    }
    static hideWrapper(el) {
        $(el).removeClass('open');
        $(el).next().removeClass('active');
        NextSteps.closeNextStepsMenu();
    }
    static showWrapper(el) {
        $(el).addClass('open');
        $(el).next().addClass('active');
    }
    resized() {
        if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
            MobileHeader.hideWrapper(this.trigger);
        }
        this.makeMenuPosAndHeight();
    }
}

export default MobileHeader;
